import { useState } from 'react';
import { navSections } from '@/mocks/home';

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="bg-background-50">
      {/* thin utility bar */}
      <div className="border-b border-secondary-200 bg-background-100">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-1 px-4 py-1.5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <span className="whitespace-nowrap">
            <i className="ri-archive-2-line mr-1" />
            内容归档 · 细节持续追加中
          </span>
          <span className="hidden items-center gap-4 whitespace-nowrap sm:flex">
            <span className="text-accent-700">
              <i className="ri-time-line mr-1" />
              排序以事件先后为准
            </span>
            <span>最近更新 · 刚刚</span>
          </span>
        </div>
      </div>

      {/* masthead */}
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 md:px-6">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-focus-3-line text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <h1 className="font-heading text-2xl font-black tracking-wide text-foreground-950">
              九色<span className="text-primary-500">黑料</span>
            </h1>
            <span className="mt-1 text-[11px] tracking-[0.2em] text-foreground-500">
              实锤 · 内幕 · 深扒
            </span>
          </span>
        </a>

        {/* search (decorative) */}
        <div className="hidden w-64 items-center gap-2 rounded-md border border-secondary-300 bg-background-50 px-3 py-2 text-sm text-foreground-400 md:flex">
          <i className="ri-search-line" />
          <input
            type="text"
            placeholder="按专题 / 人物 / 时段检索"
            className="w-full bg-transparent outline-none placeholder:text-foreground-400"
          />
        </div>

        <a
          href="#collections"
          className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 md:inline-flex"
        >
          进入专题合集
          <i className="ri-arrow-right-line ml-1" />
        </a>

        <button
          type="button"
          aria-label="菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md border border-secondary-300 text-foreground-700 md:hidden"
          onClick={() => setOpen((v) => !v)}
        >
          <i className={open ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'} />
        </button>
      </div>

      {/* section nav */}
      <nav className="sticky top-0 z-30 border-y border-secondary-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center gap-1 px-4 py-2 md:px-6">
          {navSections.map((s) => (
            <a
              key={s.anchor}
              href={s.anchor}
              className="whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium text-foreground-700 hover:bg-secondary-100 hover:text-primary-700"
            >
              {s.label}
            </a>
          ))}
          <span className="ml-auto hidden items-center gap-1 text-xs text-foreground-500 sm:flex">
            <i className="ri-fire-fill text-accent-500" />
            全网 340+ 专题持续归档
          </span>
        </div>

        {open && (
          <div className="border-t border-secondary-200 bg-background-50 md:hidden">
            <div className="mx-auto flex max-w-6xl flex-col px-4 py-2">
              {navSections.map((s) => (
                <a
                  key={s.anchor}
                  href={s.anchor}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2 text-sm text-foreground-700 hover:bg-secondary-100"
                >
                  {s.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}